module.exports = __webpack_public_path__ + "static/images/components/UpgradeIcon/images/arrow-0.2f95a547.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeIcon/images/arrow-0.png
// module id = 2695
// module chunks = 11